import { render, staticRenderFns } from "./MoreElements.vue?vue&type=template&id=2117acd5&"
import script from "./MoreElements.vue?vue&type=script&lang=js&"
export * from "./MoreElements.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports